import { render } from "./NotifikasiLonceng.vue?vue&type=template&id=09e10c45&scoped=true"
import script from "./NotifikasiLonceng.vue?vue&type=script&lang=js"
export * from "./NotifikasiLonceng.vue?vue&type=script&lang=js"

import "./NotifikasiLonceng.vue?vue&type=style&index=0&id=09e10c45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e10c45"]])

export default __exports__